var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", staticStyle: { width: "100%" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "box",
        },
        [
          _c(
            "div",
            { staticClass: "el-menu-input" },
            [
              _c("div", { staticClass: "titleBox" }, [
                _vm._m(0),
                _c("i", {
                  staticClass: "el-icon-refresh",
                  on: { click: _vm.treeAxios },
                }),
              ]),
              _c("el-input", {
                attrs: { placeholder: "输入关键字进行查询" },
                model: {
                  value: _vm.filterText,
                  callback: function ($$v) {
                    _vm.filterText = $$v
                  },
                  expression: "filterText",
                },
              }),
              _c("el-tree", {
                ref: "tree",
                staticClass: "el-menu-vertical-demo",
                attrs: {
                  data: _vm.departmentList,
                  props: _vm.defaultProps,
                  "highlight-current": true,
                  "filter-node-method": _vm.filterNode,
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "inquiryTab" }, [
            _c(
              "div",
              {
                staticClass: "titleBox",
                staticStyle: { "justify-content": "space-between" },
              },
              [
                _vm._m(1),
                _c("div", { staticClass: "btn-list tabclass" }, [
                  _c("div", {}, [
                    _vm.parArray.indexOf("bmAdd_oa") != -1
                      ? _c(
                          "div",
                          {
                            staticClass: "title-btn-item",
                            on: {
                              click: function ($event) {
                                return _vm.showDialog("新增", "add")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-plus" }),
                            _c("div", { staticClass: "btn-l" }, [
                              _vm._v("新增"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "table" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "header-cell-style": {
                        background: "#F5F5F5",
                        color: "#2F3030",
                        fontSize: "14px",
                        fontWeight: "400",
                      },
                      data: _vm.tableData,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "部门名称",
                        prop: "orgName",
                        "min-width": "105",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "left",
                                  },
                                },
                                [_vm._v("部门名称")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "left",
                                  },
                                },
                                [_vm._v(_vm._s(props.row.orgName))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "部门编号",
                        prop: "orgCode",
                        "min-width": "115",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "left",
                                  },
                                },
                                [_vm._v("部门编号")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "left",
                                  },
                                },
                                [_vm._v(_vm._s(props.row.orgCode))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "部门成员", "min-width": "84" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "p",
                                {
                                  staticClass: "pointer",
                                  style: {
                                    color:
                                      props.row.status == "S"
                                        ? "red"
                                        : "#00B498",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.staffDetails(props.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(props.row.peopleCount) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "组织类型",
                        prop: "phoneNumber",
                        "min-width": "94",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "left",
                                    },
                                  },
                                  [_vm._v("组织类型")]
                                ),
                              ]
                            },
                          },
                          {
                            key: "default",
                            fn: function (props) {
                              return _vm.dictionariesList.length > 0
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "left",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "select-type",
                                            attrs: { placeholder: "请选择" },
                                            on: {
                                              change: function ($event) {
                                                return _vm.org(props.row)
                                              },
                                            },
                                            model: {
                                              value: props.row.type,
                                              callback: function ($$v) {
                                                _vm.$set(props.row, "type", $$v)
                                              },
                                              expression: "props.row.type",
                                            },
                                          },
                                          _vm._l(
                                            _vm.dictionariesList,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.dictId,
                                                attrs: {
                                                  label: item.dictName,
                                                  value: item.dictId,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : undefined
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "负责人",
                        prop: "leaderInfo",
                        "min-width": "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "left",
                                  },
                                },
                                [_vm._v("负责人")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "left",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "select-type",
                                      attrs: {
                                        "value-key": "reallyName",
                                        placeholder: "选择负责人",
                                        size: "medium",
                                        "popper-class": "hidden",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.selectUser(props.row)
                                        },
                                      },
                                      model: {
                                        value: props.row.leaderInfo,
                                        callback: function ($$v) {
                                          _vm.$set(props.row, "leaderInfo", $$v)
                                        },
                                        expression: "props.row.leaderInfo",
                                      },
                                    },
                                    _vm._l(
                                      props.row.userList,
                                      function (user, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: user.reallyName,
                                            value: user,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "排序", prop: "sort", "min-width": "56" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "更新时间",
                        prop: "updatedTime",
                        "min-width": "158",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "left",
                                  },
                                },
                                [_vm._v("更新时间")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "left",
                                  },
                                },
                                [_vm._v(_vm._s(props.row.updatedTime))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "状态",
                        prop: "status",
                        "min-width": "70",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                  },
                                },
                                [_vm._v("状态")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                    "align-items": "center",
                                    height: "30px",
                                  },
                                },
                                [
                                  props.row.status == "A"
                                    ? _c("div", {
                                        staticStyle: {
                                          width: "8px",
                                          height: "8px",
                                          background: "#00B498",
                                          "border-radius": "50%",
                                          "margin-right": "6px",
                                          "margin-top": "2px",
                                        },
                                      })
                                    : _vm._e(),
                                  props.row.status == "S"
                                    ? _c("div", {
                                        staticStyle: {
                                          width: "8px",
                                          height: "8px",
                                          background: "#E23C58",
                                          "border-radius": "50%",
                                          "margin-right": "6px",
                                          "margin-top": "2px",
                                        },
                                      })
                                    : _vm._e(),
                                  props.row.status == "X"
                                    ? _c("div", {
                                        staticStyle: {
                                          width: "8px",
                                          height: "8px",
                                          background: "#999999",
                                          "border-radius": "50%",
                                          "margin-right": "6px",
                                          "margin-top": "2px",
                                        },
                                      })
                                    : _vm._e(),
                                  _c("div", [
                                    _vm._v(_vm._s(props.row.statusName)),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        prop: "status",
                        fixed: "right",
                        width: "84",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                  },
                                },
                                [_vm._v("操作")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _vm.parArray.indexOf("updateOrg_oa") != -1
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          color: "#00B498",
                                          cursor: "pointer",
                                          "margin-right": "8px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showDialog(
                                              "修改",
                                              "edit",
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("修改")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      color: "#f40713",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.delectTeam(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "block",
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end",
                      "margin-top": "20px",
                    },
                  },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.pageNo,
                        "page-sizes": [10, 20, 50, 100, 200],
                        "page-size": _vm.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.totalNum,
                        "prev-text": "上一页",
                        "next-text": "下一页",
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "部门成员",
                visible: _vm.dialogVisible,
                "append-to-body": true,
                width: "45%",
                "before-close": _vm.handleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialogtable" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        align: "center",
                        data: _vm.dialogDateList,
                        "header-cell-style": { background: "#f8f8f8" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "姓名",
                          "min-width": "100",
                          prop: "name",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "手机号",
                          "min-width": "100",
                          prop: "phoneNumber",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "角色", "min-width": "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(props.row.roleNameList.toString())
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm.totalNum > 0
                    ? _c("div", { staticClass: "pageDialog" }, [
                        _c(
                          "div",
                          { staticClass: "block" },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "current-page": _vm.pageNoDialog,
                                "page-sizes": [10, 20, 50, 100, 200],
                                "page-size": _vm.pageSizeDialog,
                                layout:
                                  "total, sizes, prev, pager, next, jumper",
                                total: _vm.dialogTotalNum,
                                "prev-text": "上一页",
                                "next-text": "下一页",
                              },
                              on: {
                                "size-change": _vm.handleDialogSizeChange,
                                "current-change": _vm.handleDialogCurrentChange,
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "company-dialog",
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: "600px",
            "append-to-body": true,
            "before-close": _vm.handleCloseEdit,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "eForm",
                    staticStyle: { width: "500px" },
                    attrs: {
                      model: _vm.form,
                      "label-width": "100px",
                      size: "small",
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "上级部门", prop: "parentOrgName" } },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            maxlength: "20",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.parentOrgCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "parentOrgCode", $$v)
                            },
                            expression: "form.parentOrgCode",
                          },
                        }),
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            maxlength: "20",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.parentOrgName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "parentOrgName", $$v)
                            },
                            expression: "form.parentOrgName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "部门名称", prop: "orgName" } },
                      [
                        _vm.form.dingId
                          ? _c("el-input", {
                              attrs: {
                                disabled: "",
                                placeholder: "请输入",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.form.orgName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "orgName", $$v)
                                },
                                expression: "form.orgName",
                              },
                            })
                          : _vm._e(),
                        !_vm.form.dingId
                          ? _c("el-input", {
                              attrs: {
                                "show-word-limit": "",
                                placeholder: "请输入",
                              },
                              model: {
                                value: _vm.form.orgName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "orgName", $$v)
                                },
                                expression: "form.orgName",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "部门编号", prop: "orgCode" } },
                      [
                        _vm.form.dingId
                          ? _c("el-input", {
                              attrs: {
                                disabled: "",
                                placeholder: "请输入",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.form.orgCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "orgCode", $$v)
                                },
                                expression: "form.orgCode",
                              },
                            })
                          : _vm._e(),
                        !_vm.form.dingId
                          ? _c("el-input", {
                              attrs: {
                                "show-word-limit": "",
                                placeholder: "请输入",
                              },
                              model: {
                                value: _vm.form.orgCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "orgCode", $$v)
                                },
                                expression: "form.orgCode",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "组织类型", prop: "type" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "138px" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.form.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "type", $$v)
                              },
                              expression: "form.type",
                            },
                          },
                          _vm._l(_vm.dictionariesList, function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.dialog.type == "edit"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "负责人", prop: "assignedUser" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "138px" },
                              attrs: {
                                value:
                                  _vm.form.leaderInfo &&
                                  _vm.form.leaderInfo.reallyName,
                                disabled: "",
                                "show-word-limit": "",
                                placeholder: "暂无负责人",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "排序", prop: "sort" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "138px" },
                          attrs: { "show-word-limit": "" },
                          model: {
                            value: _vm.form.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "sort", $$v)
                            },
                            expression: "form.sort",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "状态", prop: "status" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "status", $$v)
                              },
                              expression: "form.status",
                            },
                          },
                          _vm._l(_vm.dictionaries.data_status, function (item) {
                            return item.dictId !== "X"
                              ? _c(
                                  "el-radio",
                                  {
                                    key: item.dictId,
                                    attrs: {
                                      value: item.dictId,
                                      label: item.dictId,
                                      name: item.dictId,
                                    },
                                  },
                                  [_vm._v(_vm._s(item.dictName) + " ")]
                                )
                              : _vm._e()
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialog.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSubmitEdit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.isConfirm,
            width: "268px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isConfirm = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "14px",
                color: "#2F3030",
                "line-height": "22px",
                "text-align": "center",
                "margin-left": "12px",
              },
            },
            [_vm._v(" 是否确认删除该组织？")]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isConfirm = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.qDelete()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "选择负责人", multiple: false },
        on: { ok: _vm.selected },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { display: "flex", "align-items": "center" } },
      [
        _c("div", { staticClass: "division" }),
        _c("div", { staticClass: "left_title" }, [_vm._v("选择部门")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        },
      },
      [
        _c("div", { staticClass: "division" }),
        _c("div", { staticClass: "left_title" }, [_vm._v("部门列表")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }